var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        'tooltip-wrapper': true,
        'tooltip-wrapper--hidden': !_vm.pos,
    },style:({ ..._vm.wrapperStyles })},[_c('div',{ref:"tooltip",staticClass:"tooltip",style:({ ..._vm.tooltipPos })},[(_vm.$slots.header)?_c('header',[_vm._t("header")],2):_vm._e(),_c('section',[_vm._t("default")],2)]),_c('div',{staticClass:"arrow",style:({ ..._vm.arrowPos })})])
}
var staticRenderFns = []

export { render, staticRenderFns }